import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { httpService } from "../../base/services/httpService.service";
import { LocalStorageService } from "../../base/services/local-storage.service";

function ForgotPasswordConfirm() {
   const navigate = useNavigate();
   const [code, setCode] = useState();
   const userID = LocalStorageService.getItem("userId");

   const generateResetCode = () => {
      httpService.post(
         "/account/checkresetpasswordcode",
         {
            userId: userID,
            code: code
         },
         () => {
            navigate("/auth/generate-password");
         }
      );
   };

   return (
      <div className="register-popup">
         <div className="text-part">
            <h5>
               Please check email for <br /> verification code
            </h5>
         </div>
         <div className="code-part">
            <p>Enter code</p>
            <input maxLength={12} onChange={(e) => setCode(e.target.value)} className="code-area" />
         </div>
         <div className="btn-area">
            <button onClick={() => generateResetCode()} className="btn-outline">
               Done
            </button>
         </div>
      </div>
   );
}

export default ForgotPasswordConfirm;
